var map = {
	"./DragonHead.webp": 4370,
	"./Marvel.webp": 1500,
	"./alienBikeSide.webp": 5924,
	"./alienbikeAngle.webp": 2786,
	"./arcaneJinx.webp": 6506,
	"./spidy.webp": 6252,
	"./wolfy.webp": 7090,
	"./wolvCapHulk.webp": 8251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6757;